import { Component, HostListener, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { StorageService } from 'src/app/shared/services/storage.service';
import { AuthService } from 'src/app/shared/services';
import moment from 'moment';
import { interval, Subscription } from 'rxjs';
import notify from 'devextreme/ui/notify';
import { CountdownComponent } from 'ngx-countdown';
import { DxPopupComponent, DxButtonComponent } from 'devextreme-angular';

@Component({
  templateUrl: './token-expiration-check.component.html',
  selector: 'app-token-expiration-check',
  imports: [
    DxPopupComponent,
    CountdownComponent,
    DxButtonComponent
  ],
  standalone: true
})
export class TokenExpirationCheckComponent implements OnInit, OnDestroy {
  private storService = inject(StorageService);
  private authService= inject(AuthService);
  @Input() secTimer = 60;
  @Input() refreshSessionAble = false;
  @Input() minSessionDurationSec = 300;
  @Input() autoRefreshAble = false;

  alertTokenExpirating = false;
  tokenCheck: Subscription;
  showRefPopup = false;
  countDownConfig:any;


  ngOnInit() {
    this.runValidTokenCheck();
  }

  ngOnDestroy(): void {
    this.tokenCheck?.unsubscribe();
  }

  runValidTokenCheck() {
    this.tokenCheck = interval(1000 * this.secTimer).subscribe(() => {
      console.debug('check valid token');
      const currentExpTime = this.storService.currentTokenExpTime;
      if (!currentExpTime) {
        //do nothing
      } else {
        const currentMoment = moment();
        if (currentExpTime.isBefore(currentMoment)) {
          console.log('token scaduto');
          notify('Login scaduto', 'warning');
          this.authService.logOut();
        } else if (this.autoRefreshAble) {
          if (!this.alertTokenExpirating) {
            const remainingTime = moment.duration(currentExpTime.diff(currentMoment));
            const remainingSec = remainingTime.asSeconds();
            if (remainingSec <= this.minSessionDurationSec) {
              this.alertTokenExpirating = true;              
              notify('Il Token sta scadendo', 'warning');
            }
          }
        } else if (this.refreshSessionAble && !this.showRefPopup) {
          const remainingTime = moment.duration(currentExpTime.diff(currentMoment));
          const remainingSec = remainingTime.asSeconds();
          if (remainingSec <= this.minSessionDurationSec) {
            this.countDownConfig = { leftTime: remainingSec, format: 'mm:ss', demand: false };
            this.showRefPopup = true;
          }
        }
      }  
    });
  }

  onRefreshSessionClick() {
    this.authService.refreshToken().subscribe(() => {
      console.log('Token aggiornato con successo');
      this.showRefPopup = false;
      this.countDownConfig = undefined;
    });
  }

  countDownHandleEvent(e) {
    if (e.action == 'done') {
      console.log('token scaduto');
      notify('Login scaduto', 'warning');
      this.authService.logOut();
    }
  }

  @HostListener('window:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    console.trace('Eseguito click su: ' + event.target);
    if (this.autoRefreshAble && this.alertTokenExpirating) {
      this.alertTokenExpirating = false;
      this.authService.refreshToken().subscribe(() => {
        console.trace('Token aggiornato con successo');
        notify('Token aggiornato automaticamente', 'success'); 
      });
    }
  }

  @HostListener('window:keydown', ['$event'])
  onDocumentKeydown(event: KeyboardEvent) {
    console.trace('Premuto tasto: ' + event.key);
    if (this.autoRefreshAble && this.alertTokenExpirating) {
      this.alertTokenExpirating = false;
      this.authService.refreshToken().subscribe(() => {
        console.log('Token aggiornato con successo');        
        notify('Token aggiornato automaticamente', 'success'); 
      });
    }
  }

}

